import { useCurrentUser } from '@artic/api-client';
import { useFeatureFlag } from '@artic/ui/feature-flag';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/products/containers')({
  staticData: {
    section: 'Columns',
    breadcrumb: 'DfMA Containers',
    clearParentBreadcrumbs: true,
  },
  component: DfmaContainersLayout,
});

/**
 * Settings > Columns > DfMA Containers — the partner-facing container views
 * (ENG-628). Gated by the planner flag for partner users;
 * Artic admins bypass the flag so they can help a partner set up before it
 * is enabled. The flag check lives in the component (not beforeLoad) because
 * FeatureFlagProvider/AuthProvider only exist in the component tree.
 */
function DfmaContainersLayout() {
  const enabled = useFeatureFlag('planner');
  const { user } = useCurrentUser();
  const isAdmin = user.email.endsWith('@artic.works') || user.email.endsWith('@trunk.works');

  if (!enabled && !isAdmin) {
    return (
      <div className="flex flex-col items-center justify-center gap-2 py-20">
        <h2 className="text-lg font-semibold">Not enabled</h2>
        <p className="text-muted-foreground text-sm">
          DfMA Containers is not enabled for your account. Contact Artic to switch it on.
        </p>
      </div>
    );
  }

  return <Outlet />;
}
